export default function Calendar() {
  return <div className="p-6 text-2xl">Calendar Screen</div>;
}